<div class="clausulas-modal">
  <button class="btn close-modal" (click)="activeModal.dismiss()">
    <i class="fas fa-times"></i>
  </button>
  <div class="d-flex justify-content-center">
    <h4>{{title}}</h4>
  </div>
  @if (showMessage) {
    <ngb-alert class="mt-4" type="danger" [dismissible]="false">Nombre requerido</ngb-alert>
  }
  <div class="row">
    <div class="col-6">
      <div class="select-text">
        Tipo de campos
      </div>
      <select [formControl]="form.get('type')">
        @for (typesDynamic of typesDynamics; track typesDynamic) {
          <option value="{{typesDynamic.type}}">{{typesDynamic.name}}</option>
        }
      </select>
    </div>
    <div class="col-6">
      @if (form.get('type').value == 2) {
        <form [formGroup]="form">
          <div class="col-12">
            <div class="select-text">
              Campo texto
            </div>
            <input type="text" class="custom-input" formControlName="name" placeholder="Nombre" />
          </div>
        </form>
      }
      @if (form.get('type').value == 5) {
        <form [formGroup]="form">
          <div class="col-12">
            <div class="select-text">
              Campo select
            </div>
            <div class="input-group mb-3">
              <input type="text" class="form-control" formControlName="name" placeholder="Nombre" />
              <div class="input-group-prepend padding-left">
                <button class="btn white-button" (click)="addCustomfield()"><i class="fas fa-plus"></i></button>
              </div>
            </div>
          </div>
        </form>
      }
      @if (form.get('type').value == 3) {
        <form [formGroup]="form">
          <div class="col-12">
            <div class="select-text">
              Campo fecha
            </div>
            <input type="text" class="custom-input" formControlName="name" placeholder="Nombre" />
          </div>
        </form>
      }
    </div>

    <div class="col-12">
      @if (form.get('type').value == 5) {
        <form [formGroup]="form">
          <div formArrayName="select" class="row">
            @for (curren of allItems['controls']; track curren; let i = $index) {
              <div class="col-6 p-2">
                <div class="input-group mb-3">
                  <input type="text" class="form-control" [formControl]="curren">
                  <div class="input-group-prepend padding-left">
                    <button class="btn white-button" (click)="removeNewCustomField(i)"><i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </form>
    }
  </div>
</div>
<div class="d-flex justify-content-center">
  @if (emptyButton && statusModal === false) {
    <button class="mx-2 round-button-green"
      (click)="activeModal.close({subject: undefined, parent: undefined})">
      {{emptyButton}}
    </button>
  }
  @if (statusModal === false) {
    <button class="mx-2 round-button" (click)="aceppt()">
      Aceptar
    </button>
  }
  @if (statusModal && emptyButton) {
    <button class="mx-2 round-button-green" (click)="confirm(true)">
      {{emptyButton}}
    </button>
  }
  @if (statusModal) {
    <button class="mx-2 round-button" (click)="confirm(false)">
      Aceptar
    </button>
  }

</div>
</div>